import { useState } from 'react'
import { Box, Stack, Typography } from '@mui/material'

import { Info } from '@phosphor-icons/react'

type Props = {
  onClick: () => void
}

export function InfographicButton(props: Props) {
  return (
    <>
      <Stack
        alignItems='center'
        spacing={1}
        onClick={props.onClick}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 50,
            height: 50,
            border: '1px solid #c3c3c3',
            borderRadius: 1,
            cursor: 'pointer',
            transition: 'background 0.2s',
            '&:hover': {
              background: '#f5f5f5'
            }
          }}
        >
          <Info fontSize={26} />
        </Box>
        <Typography variant='body2'>Infographic</Typography>
      </Stack>
    </>
  )
}
